<template lang="pug">
  component(:is='getComponent')
</template>

<script>
import { isPC } from '@/utils'
import loginPc from './login-pc'
import loginApp from './login-app'
export default {
  components: {
    loginPc,
    loginApp,
  },
  computed: {
    getComponent() {
      return isPC() ? loginPc : loginApp
    },
  },
}
</script>
